import { createReducer } from "@reduxjs/toolkit";
import { resetRetrieveAdminStudio, retrieveAdminStudio } from "./retrieve-admin-studio";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminStudioListItem } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<AdminStudioListItem | null> = {
  fetching: "idle",
  data: null,
};

export const retrieveAdminStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(retrieveAdminStudio.pending, state => {
      state.fetching = "pending";
    })
    .addCase(retrieveAdminStudio.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(retrieveAdminStudio.rejected, state => {
      state.fetching = "failed";
    })
    .addCase(resetRetrieveAdminStudio, () => {
      return initialState;
    });
});
